import {CustomerCategoryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createCustomerCategory(
    userData: Record<string, string>,
    customerCategory: Record<string, any>
) {
    try {
        const result = await CustomerCategoryDao.createCustomerCategory(userData.userToken, customerCategory);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
